module.exports = __webpack_public_path__ + "img/banner2.eb184663.png";